// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchResultHeading_wrapper__rt_Jw","searchTerm":"SearchResultHeading_searchTerm__IPDs_","markdown":"SearchResultHeading_markdown__x4X6p"};